import { useMutation, useQueryClient } from '@tanstack/react-query';
import { licensesManageService } from '../api/licensesManageService';
import type {
  BulkLicenseActionResultDto,
  BulkLicenseIdsWithReasonDto,
  BulkExtendLicensesDto,
} from '../types/manageLicenses';

export function useBulkLicenseActions() {
  const qc = useQueryClient();
  const invalidate = () => qc.invalidateQueries({ queryKey: ['manage-licenses'] });

  const revoke = useMutation<BulkLicenseActionResultDto, Error, BulkLicenseIdsWithReasonDto>({
    mutationFn: (dto) => licensesManageService.bulkRevoke(dto),
    onSuccess: invalidate,
  });

  const suspend = useMutation<BulkLicenseActionResultDto, Error, BulkLicenseIdsWithReasonDto>({
    mutationFn: (dto) => licensesManageService.bulkSuspend(dto),
    onSuccess: invalidate,
  });

  const reactivate = useMutation<BulkLicenseActionResultDto, Error, string[]>({
    mutationFn: (licenseIds) => licensesManageService.bulkReactivate(licenseIds),
    onSuccess: invalidate,
  });

  const extend = useMutation<BulkLicenseActionResultDto, Error, BulkExtendLicensesDto>({
    mutationFn: (dto) => licensesManageService.bulkExtend(dto),
    onSuccess: invalidate,
  });

  return { revoke, suspend, reactivate, extend };
}
